let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("77e95")).then(() => parcelRequire('22eIY'));